import Instance from '../../../../../utils/Axios';

const AdicionarRegistoEscritorio = (ydata, show) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/registohorasescritorio/horas', { ydata })
      .then(({ data }) => {
        console.log(ydata);
        if (stateToken) {
          dispatch({ type: 'POST_REGISTO_ESCRITORIO', payload: data });
          show('success', 'Novo Registo efetuado!');
        }
      })
      .catch((err) => {
        console.log(err, err.response, err.request);
        if (!err.response) {
          console.log('Problema de conexão.');
          show('danger', `Problema de conexão com o servidor.`);
        } else if (err.response) {
          if (err.response.status === 500) {
            show('danger', `${err.response.data.message}`);
          } else {
            console.log('4xx - Problema de conexão.');
            show('danger', `Problema de conexão com o servidor.`);
          }
        }
      });
  }
};

export default AdicionarRegistoEscritorio;
